// This icon file is generated automatically.
var PArrowsAltOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.36.5L8.4.87a.12.12 0 00-.07.21l.85.85-2.4 2.4a.13.13 0 000 .18l.71.7c.05.05.13.05.18 0l2.4-2.4.85.86c.08.07.2.03.21-.07L11.5.64a.12.12 0 00-.14-.14zM4.5 6.8a.13.13 0 00-.18 0l-2.4 2.4-.85-.86a.12.12 0 00-.21.07L.5 11.36c0 .08.06.15.14.14l2.96-.37c.1-.01.14-.14.07-.21l-.85-.85 2.4-2.4a.13.13 0 000-.18l-.71-.7z", "fill-rule": "nonzero" } }] }, "name": "p-arrows-alt", "theme": "outlined" };
export default PArrowsAltOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PArrowsAltOutlined.js
// module id = 3216
// module chunks = 0